import { ChangeDetectionStrategy, Component, Signal, WritableSignal, afterNextRender, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { version } from '@package.json';
import { BlockDirective, ElemDirective, ModDirective } from '@rt-tools/core';

/**
 * Year baked in at bundle time. Served to SSR and the hydration pass so the
 * DOM matches. `afterNextRender` then updates the signal to the client's
 * actual current year, which only differs during a brief window around
 * New Year when server and client disagree.
 */
const FALLBACK_YEAR: number = 2026;
const BEM_BLOCK: string = 'sc-app-footer';

@Component({
    selector: 'sc-app-footer',
    templateUrl: './app-footer.component.html',
    styleUrl: './app-footer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // angular
        RouterLink,
        RouterLinkActive,

        // rt-tools
        BlockDirective,
        ElemDirective,
        ModDirective,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export class AppFooterComponent {
    readonly #year: WritableSignal<number> = signal<number>(FALLBACK_YEAR);

    protected readonly currentYear: Signal<number> = this.#year.asReadonly();
    protected readonly appVersion: string = version;

    constructor() {
        afterNextRender((): void => {
            this.#year.set(new Date().getFullYear());
        });
    }
}
